import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * The wordmark.
 *
 * One SVG rather than the previous light/dark pair. The mark is a purse drawn
 * as an outline, so it only needs a single ink colour and can take it from the
 * surrounding text: which means it is correct on the band, on the light
 * ground and on the dark ground without three copies of the same path.
 */
@Component({
  selector: 'layout-logo',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="flex items-center gap-4">
      <svg
        width="34"
        height="34"
        viewBox="0 0 40 40"
        fill="none"
        aria-hidden="true"
        class="flex-none"
      >
        <circle
          cx="20"
          cy="20"
          r="19"
          [attr.stroke]="onBand() ? 'var(--color-accent-300)' : 'var(--color-accent-stroke)'"
          stroke-width="1.5"
        />
        <path
          d="M16 30C14.3148 30 12.8935 29.4213 11.7361 28.2639C10.5787 27.1065 10 25.6852 10 24C10 23.2963 10.1204 22.6111 10.3611 21.9444C10.6019 21.2778 10.9444 20.6759 11.3889 20.1389L15.3333 15.3889L12.6389 10H27.3611L24.6667 15.3889L28.6111 20.1389C29.0556 20.6759 29.3981 21.2778 29.6389 21.9444C29.8796 22.6111 30 23.2963 30 24C30 25.6852 29.4167 27.1065 28.25 28.2639C27.0833 29.4213 25.6667 30 24 30H16ZM20 24.4444C19.3889 24.4444 18.8657 24.2269 18.4306 23.7917C17.9954 23.3565 17.7778 22.8333 17.7778 22.2222C17.7778 21.6111 17.9954 21.088 18.4306 20.6528C18.8657 20.2176 19.3889 20 20 20C20.6111 20 21.1343 20.2176 21.5694 20.6528C22.0046 21.088 22.2222 21.6111 22.2222 22.2222C22.2222 22.8333 22.0046 23.3565 21.5694 23.7917C21.1343 24.2269 20.6111 24.4444 20 24.4444ZM17.3611 14.4444H22.6389L23.75 12.2222H16.25L17.3611 14.4444ZM16 27.7778H24C25.0556 27.7778 25.9491 27.412 26.6806 26.6806C27.412 25.9491 27.7778 25.0556 27.7778 24C27.7778 23.5556 27.6991 23.125 27.5417 22.7083C27.3843 22.2917 27.1667 21.9167 26.8889 21.5833L22.8056 16.6667H17.2222L13.1111 21.5556C12.8333 21.8889 12.6157 22.2685 12.4583 22.6944C12.3009 23.1204 12.2222 23.5556 12.2222 24C12.2222 25.0556 12.588 25.9491 13.3194 26.6806C14.0509 27.412 14.9444 27.7778 16 27.7778Z"
          fill="currentColor"
        />
      </svg>

      <!--
        The wordmark is 15/500 with the system's tracking, not a bold logotype:
        weight never exceeds 500 anywhere in Nocturne, including here.
      -->
      <span class="text-[15px] font-medium tracking-[-0.01em]">Ledgerly</span>
    </span>
  `,
})
export class LogoComponent {
  readonly onBand = input(false);
}
